<div class="card mt-1 bg-light">
  <div class="card-body">
    <h4>Create Client Chore</h4>
    @if (hasError) {
      <div class="alert alert-danger">
        There was a problem uploading client chore list. All fields are required. Please try again.
        <ul class="mt-2">
          @for (error of errors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    }
    <section class="row mt-1">
      <div class="mb-3 col-12">
        <label for="selectedChore">Select A Chore</label>
        <select class="form-select"
          [(ngModel)]="selectedChore"
          name="selectedChore"
          (change)="onSelectedChoreChange()">

          <option [ngValue]="null"> -- Select Chore -- </option>

          @for (availableChore of availableChores; track availableChore) {
            <option [ngValue]="availableChore">
              {{ availableChore.displayName }}
            </option>
          }
        </select>
        @if (selectedChore && selectedChore.description) {
          <div class="mt-3 mb-0 alert alert-info">
            <strong>NOTE:</strong> {{ selectedChore.description }}
          </div>
        }
      </div>

      @if (showClientField()) {
        <div class="mb-3 col-12">
          <label for="selctedClient">Select A Client</label>
          <select class="form-select" [(ngModel)]="selectedClientId" name="selectedClient">
            <option [ngValue]="null"> -- Select Client -- </option>
            @for (client of clients; track client) {
              <option [ngValue]="client.id">{{ client.humanizedName }}</option>
            }
          </select>
        </div>
      }

      @if (showFormFields()) {
        <div>
          @for (field of selectedChore.inputs.form.fields; track field) {
            <div class="mb-3 col-12">
              @if (field.type === 'checkbox') {
                <input type="checkbox"
                  [name]="field.name"
                  [id]="field.name"
                  [(ngModel)]="params[field.name]" />
              }

              <label [for]="field.name">
                <strong>{{ field.label }}</strong>
              </label>
              <br/>

              <em>{{ field.description }}</em>

              @if (field.type === 'select') {
                <ng-select
                  class="w-100"
                  bindValue="id"
                  bindLabel="label"
                  [name]="field.name"
                  [placeholder]="field.placeholder"
                  [multiple]="field.multiple"
                  [items]="field.options"
                  [(ngModel)]="params[field.name]" />
              }
              @if (field.type === 'capture_status_reasons_select') {
                <app-capture-status-and-reason-select
                  [name]="field.name"
                  [placeholder]="field.placeholder"
                  [multiple]="field.multiple"
                  [items]="field.options"
                  [(model)]="params[field.name]" />
              }
            </div>
          }
        </div>
      }

      @if (showNotesField()) {
        <div class="mb-3 col-12">
          <label><strong>Notes</strong></label><br/>
          <textarea
            name="notes"
            class="form-control phi"
            required
            [(ngModel)]="notes"
          maxlength="200"></textarea>
        </div>
      }

      @if (showFileRequirements()) {
        <div>
          <strong>File Requirements</strong>
          <ol class="mx-3 mb-1 ps-2">
            <li class="pb-2">
              Columns
              @for (column of selectedChore.inputs.file.columns; track column) {
                <ul class="ps-2">
                  <li>
                    <code>{{column.name}}</code>
                    <small>
                      <span>{{formattedDescription(column)}}</span>
                    </small>
                  </li>
                </ul>
              }
            </li>
            <li class="pb-2">
              Example file
              <div>
                <small><strong>NOTE:</strong> Extra columns will be ignored and column headers are case insensitive and underscores are optional.</small>
              </div>
              <div class="bg-light p-2 border w-100">
                <small>
                  <strong>
                    <code class="csv-header">
                      @for (column of selectedChore.inputs.file.columns; track column) {
                        <span> {{column.name}}</span>
                      }
                    </code>
                  </strong>
                  <br />
                  <code>@for (column of selectedChore.inputs.file.columns; track column) {
                    <span> {{column.example}}</span>
                  }</code><br />
                </small>
              </div>
            </li>
            <li class="pb-2">
              <code>{{fileUploadType}}</code>
              @if (selectedChore.inputs.file.encoding) {
                <small>
                  <span>(encoding: {{selectedChore.inputs.file.encoding}})</span>
                </small>
              }
            </li>
          </ol>
        </div>
      }

      <div class="col-12" [hidden]="!showFileUpload()">
        <app-file-upload
          [hidden]="uploadingFile"
          (uploadStart)="onUploadStart()"
          (uploadComplete)="onUploadComplete($event)"
          (uploadError)="onUploadError($event)"
          (uploadCancel)="onCancelClick()"
          [uploadButtonDisabled]="!formValid"
          [directUploadPath]="directUploadPath"
          [alwaysShowButtons]="true"
          [fileType]="fileUploadType" />
        <div class="py-2" [hidden]="!uploadingFile">
          <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" />
          Uploading file...
        </div>
      </div>

      @if (showCreateButton()) {
        <div class="mb-3 col-12">
          <button
            type="submit"
            class="btn btn-primary"
            (click)="onSubmit()"
            [disabled]="!formValid">
            Start
          </button>
          <button type="button" class="btn btn-secondary"
            (click)="onCancelClick()">
            Cancel
          </button>
        </div>
      }
    </section>
  </div>
</div>
